'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareButtonComponent = CompareButtonComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _bdcoreData = require('@bd/bdcore-data');

var _bdcoreData2 = _interopRequireDefault(_bdcoreData);

var _actions = require('@bd/bdcore-data/build/Compare/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CompareButtonComponent(_ref) {
  var className = _ref.className,
      compare = _ref.compare,
      dispatch = _ref.dispatch,
      id = _ref.id,
      limit = _ref.limit,
      text = _ref.text,
      type = _ref.type;

  return _react2.default.createElement(
    'span',
    {
      role: 'button',
      tabIndex: 0,
      className: className,
      onClick: function onClick() {
        return dispatch((0, _actions.toggleCompareItem)({ id: id, type: type, limit: limit }));
      }
    },
    _react2.default.createElement('span', { className: 'CompareButton_indicator ' + ((0, _lodash.get)(compare, 'items', []).reduce(function (res, item) {
        return res || (0, _lodash.get)(item, '_id') === id;
      }, false) ? 'CompareButton_indicator-active' : '') }),
    _react2.default.createElement(
      'span',
      { className: 'CompareButton_text' },
      text
    )
  );
}

CompareButtonComponent.propTypes = {
  className: _propTypes2.default.string,
  /** IGNORE: fetched from data automatically */
  compare: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    items: _propTypes2.default.arrayOf(_propTypes2.default.object)
  }).isRequired,
  dispatch: _propTypes2.default.func,
  id: _propTypes2.default.string.isRequired,
  limit: _propTypes2.default.number,
  text: _propTypes2.default.string,
  type: _propTypes2.default.string.isRequired
};

CompareButtonComponent.defaultProps = {
  className: undefined,
  dispatch: function dispatch() {},
  limit: _propTypes2.default.number,
  text: 'Compare'
};

exports.default = (0, _bdcoreData2.default)({ compare: true })(CompareButtonComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-compare/build/CompareButton.js
// module id = 1197
// module chunks = 0